<section class="historial-cambios-modal">
  <header class="historial-cambios-modal__header">
    <div>
      <h2>Historial de cambios</h2>
      <p>Registre el cambio realizado y la persona que lo autoriza.</p>
    </div>
    <button type="button" mat-icon-button class="historial-cambios-modal__close" (click)="onNoClick()"
      aria-label="Cerrar historial de cambios" matTooltip="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="historialCambios" autocomplete="off" class="historial-cambios-modal__form">
    <mat-form-field appearance="outline" class="historial-cambios-modal__field historial-cambios-modal__field--wide">
      <mat-label>Descripción</mat-label>
      <textarea matInput maxlength="500" rows="4" formControlName="descripcion"
        [(ngModel)]="objetoHistorial.descripcion" aria-label="Descripción"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="historial-cambios-modal__field">
      <mat-label>Autoriza</mat-label>
      <mat-select name="empleadoAutoriza" placeholder="Elige empleado" [(ngModel)]="objetoHistorial.autoriza"
        formControlName="autortiza">
        <ngx-mat-select-search [formControl]="formCliente" [placeholderLabel]="'Buscar empleado'"
          [noEntriesFoundLabel]="'No existe empleado'" (click)="clearNombreCli()"></ngx-mat-select-search>
        <mat-option *ngFor="let item of listaDEmpleados" [value]="item.persona.nombreCompleto">
          {{ item.persona.nombreCompleto }}
        </mat-option>
      </mat-select>
      <button type="button" mat-icon-button matSuffix (click)="clearNombreCli()" aria-label="Limpiar empleado">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error *ngIf="historialCambios.get('autortiza')?.hasError('required')">
        Seleccione quién autoriza el cambio.
      </mat-error>
    </mat-form-field>

    <div class="historial-cambios-modal__type">
      <span>Tipo de cambio</span>
      <strong>{{ data.tipo_cambio }}</strong>
    </div>

    <footer class="historial-cambios-modal__footer">
      <button type="button" mat-stroked-button class="app-form-btn app-form-btn--secondary" (click)="onNoClick()">
        Cancelar
      </button>
      <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary" (click)="save()">
        <mat-icon>save</mat-icon>
        Guardar cambio
      </button>
    </footer>
  </form>
</section>
